var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
var CountTextField = function (props) {
    var _a;
    var sx = props.sx, InputProps = props.InputProps, onChange = props.onChange, onChangeValue = props.onChangeValue, disabled = props.disabled, value = props.value, textFieldProps = __rest(props, ["sx", "InputProps", "onChange", "onChangeValue", "disabled", "value"]);
    var getNumericValue = function () { return parseInt(value) || 0; };
    return (_jsx(TextField, __assign({}, textFieldProps, { value: value, disabled: disabled, type: "number", sx: __spreadArray([
            {
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0
                },
                "& input[type=number]": {
                    MozAppearance: "textfield"
                }
            }
        ], (Array.isArray(sx) ? sx : sx ? [sx] : []), true), onFocus: function (e) { return e.target.select(); }, InputProps: __assign(__assign({}, InputProps), { startAdornment: (_jsx(IconButton, __assign({ onClick: function () {
                    var nextValue = getNumericValue();
                    if (nextValue > 0) {
                        nextValue = nextValue - 1;
                    }
                    onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(nextValue);
                }, disabled: disabled }, { children: _jsx(RemoveIcon, {}) }))), endAdornment: (_jsx(IconButton, __assign({ onClick: function () {
                    var nextValue = getNumericValue() + 1;
                    onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(nextValue);
                }, disabled: disabled }, { children: _jsx(AddIcon, {}) }))), inputProps: __assign(__assign({}, InputProps === null || InputProps === void 0 ? void 0 : InputProps.inputProps), { style: __assign(__assign({}, (_a = InputProps === null || InputProps === void 0 ? void 0 : InputProps.inputProps) === null || _a === void 0 ? void 0 : _a.style), { textAlign: 'center' }) }) }), onChange: function (e) {
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(e.target.value ? parseInt(e.target.value) : undefined);
        } })));
};
export default CountTextField;
